<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { StubEnum } from './enums';
import {
  AccessDeniedTask,
  InvalidUrl,
  QueueDeleted,
  TaskNotFound,
  WorkspaceRemoval,
} from './components';
import { useRouter } from 'vue-router';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-components';
import { ArrowUturnLeftIcon } from 'tir-style-system/icons/outline';

/**Роутер */
const router = useRouter();

/**код ошибки */
const errorCode = ref(router.currentRoute.value.query.errorCode as string);

/**Перед рендером компонента */
onBeforeMount(() => {
  if (!errorCode.value) router.back();
});
/**После рендера компонента */
onMounted(() => {
  router.replace({ query: { errorCode: undefined } });
});

/**Отображение заглушки взависимости от кода ошибки */
const getStubByErrorCode = computed(() => {
  switch (errorCode.value) {
    case StubEnum.WorkspaceRemoval:
    case StubEnum.QueueAccessDenied:
      return WorkspaceRemoval;
    case StubEnum.QueueDeleted:
      return QueueDeleted;
    case StubEnum.TaskNotFound:
      return TaskNotFound;
    case StubEnum.InvalidUrl:
      return InvalidUrl;
    default:
      return AccessDeniedTask;
  }
});

/**Вернуться назад */
const goBack = () => {
  router.push({ name: 'project-namespaces' });
};
</script>

<template>
  <TirPmButton
    :size="TirPmButtonSizeEnum.Regular"
    :variant="TirPmButtonVariantEnum.SecondaryState"
    @click="goBack"
  >
    <template #leftSlot>
      <ArrowUturnLeftIcon />
    </template>
  </TirPmButton>
  <component :is="getStubByErrorCode" />
</template>
